import {useCallback} from 'react';
import type {CreateFlowFeatureControllerToggleProps} from '~/CreateFabricInvitation/types/types';
import {InvitationWidget} from '~/common/components/InvitationWidget/InvitationWidget';
import {EventFeature} from '~/common/types/event';
import {CameraIcon} from '~library/svg/v2/CameraIcon';

import {pebble} from '~libSass/base/_exports.sass';

export const PhotoSharingToggle = ({
  handleOnClick,
  active,
  hide = false,
}: CreateFlowFeatureControllerToggleProps) => {
  const handleClick = useCallback(() => {
    handleOnClick?.(EventFeature.PHOTO_SHARING);
  }, [handleOnClick]);

  return (
    <InvitationWidget.Toggle
      filled={active}
      title="Shared photo album"
      subtitle={
        active ? 'Photos will appear on your Invitation.' : 'Gather host & guest pics in one place.'
      }
      qaId="photo-sharing-toggle"
      onClick={handleClick}
      hide={hide}
      startAdornment={<CameraIcon ratio={0.75} color={pebble} />}
    />
  );
};
